var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('va-polygon-field',{attrs:{"polygons":_vm.polygons,"zoom":8,"height":"500px"}}),_c('base-material-card',{attrs:{"icon":_vm.resource.icon,"title":_vm.title}},[_c('va-list',{attrs:{"filters":_vm.filters,"include":[
        'manure_storage_type_entity',
        'manure_type_entity',
        'containment_type_entity',
        'storage_handling_adequate_entity',
      ]},on:{"update:listState":_vm.onListStateUpdate}},[_c('va-data-table',{attrs:{"fields":_vm.fields,"disable-clone":""}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }